export const ECustomSummmarizedflow = {
  NOCUSTOM: false,
  SANOFI: 'SANOFI',
}
